module.exports = __webpack_public_path__ + "static/media/loader.569510db.gif";